import { Box, Stack, CircularProgress } from '@mui/material';

export default function LoadingSpinner() {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
      }}
    >
      <Stack
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size={80} />
      </Stack>
    </Box>
  );
}
